import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { API } from 'helpers/api/endpoints';
import { env_backend_url } from 'env_Variables';
import { sanitizeMailPreviewHtml } from './MailTemplateVariablesPanel';

type Props = {
  value: string;
  onChange: (html: string) => void;
  onReady?: (editor: any) => void;
  onImageUploaded?: (url: string) => void;
  token?: string;
  readOnly?: boolean;
};

export default function MailRichTextEditor({value, onChange, onReady, onImageUploaded, token, readOnly }: Props) {
  const previewValue = readOnly
    ? sanitizeMailPreviewHtml(value)
    : value;

  return (
    <CKEditor
      editor={ClassicEditor as any}
      data={previewValue}
      onReady={(editor) => {
        editor.enableReadOnlyMode('mail-preview');

        if (!readOnly) {
          editor.disableReadOnlyMode('mail-preview');
          editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) =>
            new ImageUploadAdapter(loader, token, onImageUploaded);
        }

        onReady?.(editor);
      }}
      onChange={(_, editor) => {
        if (!readOnly && onChange) {
          onChange(editor.getData());
        }
      }}
      config={{
        toolbar: readOnly
          ? []
          : [
              'heading', '|',
              'bold', 'italic', '|',
              'bulletedList','numberedList','|',
              'insertTable', '|',
              // 'imageUpload', '|',
              'undo', 'redo'
            ]
      }}
    />
  );
}

class ImageUploadAdapter {
  loader: any;
  token?: string;
  onImageUploaded?: (url: string) => void;

  constructor(
    loader: any,
    token?: string,
    onImageUploaded?: (url: string) => void
  ) {
    this.loader = loader;
    this.token = token;
    this.onImageUploaded = onImageUploaded;
  }


  async upload() {
    const file = await this.loader.file;

    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(
      `${env_backend_url}${API.mail.uploadImage}`,
      {
        method: 'POST',
        headers: this.token
          ? { Authorization: `Bearer ${this.token}` }
          : undefined,
        body: formData
      }
    );

    if (!response.ok) {
      throw new Error('Image upload failed');
    }

    const data = await response.json();

    const imageUrl = data.url.startsWith('http')
      ? data.url
      : `${env_backend_url}${data.url}`;

    this.onImageUploaded?.(imageUrl);

    return {
      default: imageUrl
    };

  }

  abort() {}
}
